<template>
  <div>
    <el-button type="primary" @click="toggleDialogVisible(true)">
      注入奖池
    </el-button>
    <el-dialog
      title="注入奖池"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      width="500px"
    >
      <el-form :model="form" ref="form" label-width="140px">
        <el-form-item
          label="金额(USDT)："
          prop="amount"
          :rules="[{ required: true, message: '金额不能为空' }]"
        >
          <el-input type="text" v-model="form.amount"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleDialogVisible(false)">取消</el-button>
        <el-button type="primary" @click="handleSubmit('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DividendUpdateProfit',
  data() {
    return {
      dialogVisible: false,
      form: {
        amount: null
      }
    };
  },
  methods: {
    ...mapActions('dividendTask', ['updateProfit']),
    toggleDialogVisible(visible) {
      this.dialogVisible = visible;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
    },
    handleSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.updateProfit(this.form).then(() => {
            this.$message.success('注入成功！');
            this.toggleDialogVisible(false);
            this.$emit('onSuccess');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
